import { beginText, closePath, drawObject, endText, fill, fillAndStroke, lineTo, moveTo, nextLine, popGraphicsState, pushGraphicsState, rotateAndSkewTextRadiansAndTranslate, rotateRadians, setFontAndSize, setLineHeight, setLineWidth, setLineJoin, setLineMiterLimit, showText, skewRadians, stroke, setLineCap, rotateDegrees, setGraphicsState, setDashPattern, beginMarkedContent, endMarkedContent, clip, endPath, } from "./operators";
import { 
//   ColorTypes,
setFillingColor, setStrokingColor, } from "./colors";
import { degrees, toRadians } from "./rotations";
import { path, line, circle, ellipse, rect } from "./shape";
import { asNumber } from "./objects";
import { translate, scale } from "./transform";
export const drawText = (text, options) => [
    pushGraphicsState(),
    options.graphicsState && setGraphicsState(options.graphicsState),
    beginText(),
    setFillingColor(options.color),
    setFontAndSize(options.font, options.size),
    rotateAndSkewTextRadiansAndTranslate(toRadians(options.rotate), toRadians(options.xSkew), toRadians(options.ySkew), options.x, options.y),
    showText(text),
    endText(),
    popGraphicsState(),
].filter(Boolean);
export const drawLinesOfText = (lines, options) => {
    const ops = [
        pushGraphicsState(),
        options.graphicsState && setGraphicsState(options.graphicsState),
        beginText(),
        setFillingColor(options.color),
        setFontAndSize(options.font, options.size),
        setLineHeight(options.lineHeight),
        rotateAndSkewTextRadiansAndTranslate(toRadians(options.rotate), toRadians(options.xSkew), toRadians(options.ySkew), options.x, options.y),
    ].filter(Boolean);
    for (let idx = 0, len = lines.length; idx < len; idx++) {
        ops.push(showText(lines[idx]), nextLine());
    }
    ops.push(endText(), popGraphicsState());
    return ops;
};
export const drawImage = (name, options) => [
    pushGraphicsState(),
    options.graphicsState && setGraphicsState(options.graphicsState),
    translate(options.x, options.y),
    rotateRadians(toRadians(options.rotate)),
    scale(options.width, options.height),
    skewRadians(toRadians(options.xSkew), toRadians(options.ySkew)),
    drawObject(name),
    popGraphicsState(),
].filter(Boolean);
export const drawPage = (name, options) => [
    pushGraphicsState(),
    options.graphicsState && setGraphicsState(options.graphicsState),
    translate(options.x, options.y),
    rotateRadians(toRadians(options.rotate)),
    scale(options.xScale, options.yScale),
    skewRadians(toRadians(options.xSkew), toRadians(options.ySkew)),
    drawObject(name),
    popGraphicsState(),
].filter(Boolean);
export const drawLine = (options) => {
    var _a, _b;
    return [
        pushGraphicsState(),
        options.graphicsState && setGraphicsState(options.graphicsState),
        options.stroke && setStrokingColor(options.stroke),
        options.strokeWidth && setLineWidth(options.strokeWidth),
        options.strokeLineCap && setLineCap(options.strokeLineCap),
        (options.strokeDashArray || options.strokeDashPhase) &&
            setDashPattern((_a = options.strokeDashArray) !== null && _a !== void 0 ? _a : [], (_b = options.strokeDashPhase) !== null && _b !== void 0 ? _b : 0),
        ...line(asNumber(options.x1), asNumber(options.y1), asNumber(options.x2), asNumber(options.y2)),
        options.stroke ? stroke() : undefined,
        popGraphicsState(),
    ].filter(Boolean);
};
export const drawRect = (options) => {
    var _a, _b;
    return [
        pushGraphicsState(),
        options.graphicsState && setGraphicsState(options.graphicsState),
        options.fill && setFillingColor(options.fill),
        options.stroke && setStrokingColor(options.stroke),
        options.strokeWidth && setLineWidth(options.strokeWidth),
        options.strokeLineCap && setLineCap(options.strokeLineCap),
        (options.strokeDashArray || options.strokeDashPhase) &&
            setDashPattern((_a = options.strokeDashArray) !== null && _a !== void 0 ? _a : [], (_b = options.strokeDashPhase) !== null && _b !== void 0 ? _b : 0),
        ...rect(asNumber(options.x), asNumber(options.y), asNumber(options.width), asNumber(options.height), options.rx ? asNumber(options.rx) : undefined, options.ry ? asNumber(options.ry) : undefined),
        // prettier-ignore
        options.fill && options.stroke ? fillAndStroke(options.fillRule)
            : options.fill ? fill(options.fillRule)
                : options.stroke ? stroke()
                    : undefined,
        popGraphicsState(),
    ].filter(Boolean);
};
export const drawEllipse = (options) => {
    var _a, _b;
    return [
        pushGraphicsState(),
        options.graphicsState && setGraphicsState(options.graphicsState),
        options.fill && setFillingColor(options.fill),
        options.stroke && setStrokingColor(options.stroke),
        options.strokeWidth && setLineWidth(options.strokeWidth),
        options.strokeLineCap && setLineCap(options.strokeLineCap),
        (options.strokeDashArray || options.strokeDashPhase) &&
            setDashPattern((_a = options.strokeDashArray) !== null && _a !== void 0 ? _a : [], (_b = options.strokeDashPhase) !== null && _b !== void 0 ? _b : 0),
        ...ellipse(asNumber(options.cx), asNumber(options.cy), asNumber(options.rx), asNumber(options.ry)),
        // prettier-ignore
        options.fill && options.stroke ? fillAndStroke(options.fillRule)
            : options.fill ? fill(options.fillRule)
                : options.stroke ? stroke()
                    : closePath(),
        popGraphicsState(),
    ].filter(Boolean);
};
export const drawCircle = (options) => {
    var _a, _b;
    return [
        pushGraphicsState(),
        options.graphicsState && setGraphicsState(options.graphicsState),
        options.fill && setFillingColor(options.fill),
        options.stroke && setStrokingColor(options.stroke),
        options.strokeWidth && setLineWidth(options.strokeWidth),
        options.strokeLineCap && setLineCap(options.strokeLineCap),
        (options.strokeDashArray || options.strokeDashPhase) &&
            setDashPattern((_a = options.strokeDashArray) !== null && _a !== void 0 ? _a : [], (_b = options.strokeDashPhase) !== null && _b !== void 0 ? _b : 0),
        ...circle(asNumber(options.cx), asNumber(options.cy), asNumber(options.r)),
        // prettier-ignore
        options.fill && options.stroke ? fillAndStroke(options.fillRule)
            : options.fill ? fill(options.fillRule)
                : options.stroke ? stroke()
                    : undefined,
        popGraphicsState(),
    ].filter(Boolean);
};
export const drawPath = (options) => {
    var _a, _b, _c;
    return [
        pushGraphicsState(),
        options.graphicsState && setGraphicsState(options.graphicsState),
        rotateRadians(toRadians((_a = options.rotate) !== null && _a !== void 0 ? _a : degrees(0))),
        options.scale && scale(options.scale, options.scale),
        options.fill && setFillingColor(options.fill),
        options.stroke && setStrokingColor(options.stroke),
        options.strokeWidth && setLineWidth(options.strokeWidth),
        options.strokeLineCap && setLineCap(options.strokeLineCap),
        (options.strokeDashArray || options.strokeDashPhase) &&
            setDashPattern((_b = options.strokeDashArray) !== null && _b !== void 0 ? _b : [], (_c = options.strokeDashPhase) !== null && _c !== void 0 ? _c : 0),
        ...path(options.d),
        // prettier-ignore
        options.fill && options.stroke ? fillAndStroke(options.fillRule)
            : options.fill ? fill(options.fillRule)
                : options.stroke ? stroke()
                    : undefined,
        popGraphicsState(),
    ].filter(Boolean);
};
export const draw = (graphic, page, options) => {
    const operators = [];
    operators.push(pushGraphicsState(), options.graphicsState ? setGraphicsState(options.graphicsState) : undefined, translate(options.x, options.y), rotateRadians(toRadians(options.rotate)), scale(options.scale, options.scale), scale(1, -1));
    if (options.clipPath) {
        options.clipPath.forEach((c) => operators.push(c));
        operators.push(clip(options.clipRule));
        operators.push(endPath());
    }
    const ops = graphicToOperators(graphic, page); // can't use spread operator or will hit max call stack
    ops.forEach((o) => operators.push(o));
    operators.push(popGraphicsState());
    return operators.filter(Boolean);
};
export const drawCheckMark = (options) => {
    const size = asNumber(options.size);
    /*********************** Define Check Mark Points ***************************/
    // A check mark is defined by three points in some coordinate space. Here, we
    // define these points in a unit coordinate system, where the range of the x
    // and y axis are both [-1, 1].
    //
    // Note that we do not hard code `p1y` in case we wish to change the
    // size/shape of the check mark in the future. We want the check mark to
    // always form a right angle. This means that the dot product between (p1-p2)
    // and (p3-p2) should be zero:
    //
    //   (p1x-p2x) * (p3x-p2x) + (p1y-p2y) * (p3y-p2y) = 0
    //
    // We can now rejigger this equation to solve for `p1y`:
    //
    //   (p1y-p2y) * (p3y-p2y) = -((p1x-p2x) * (p3x-p2x))
    //   (p1y-p2y) = -((p1x-p2x) * (p3x-p2x)) / (p3y-p2y)
    //   p1y = -((p1x-p2x) * (p3x-p2x)) / (p3y-p2y) + p2y
    //
    // Thanks to my friend Joel Walker (https://github.com/JWalker1995) for
    // devising the above equation and unit coordinate system approach!
    // (x, y) coords of the check mark's bottommost point
    const p2x = -1 + 0.75;
    const p2y = -1 + 0.51;
    // (x, y) coords of the check mark's topmost point
    const p3y = 1 - 0.525;
    const p3x = 1 - 0.31;
    // (x, y) coords of the check mark's center (vertically) point
    const p1x = -1 + 0.325;
    const p1y = -((p1x - p2x) * (p3x - p2x)) / (p3y - p2y) + p2y;
    /****************************************************************************/
    return [
        pushGraphicsState(),
        options.color && setStrokingColor(options.color),
        setLineWidth(options.thickness),
        translate(options.x, options.y),
        moveTo(p1x * size, p1y * size),
        lineTo(p2x * size, p2y * size),
        lineTo(p3x * size, p3y * size),
        stroke(),
        popGraphicsState(),
    ].filter(Boolean);
};
// prettier-ignore
export const rotateInPlace = (options) => options.rotation === 0 ? [
    translate(0, 0),
    rotateDegrees(0)
]
    : options.rotation === 90 ? [
        translate(options.width, 0),
        rotateDegrees(90)
    ]
        : options.rotation === 180 ? [
            translate(options.width, options.height),
            rotateDegrees(180)
        ]
            : options.rotation === 270 ? [
                translate(0, options.height),
                rotateDegrees(270)
            ]
                : []; // Invalid rotation - noop
export const drawCheckBox = (options) => {
    const outline = drawRect({
        x: options.x,
        y: options.y,
        width: options.width,
        height: options.height,
        strokeWidth: options.borderWidth,
        fill: options.color,
        stroke: options.borderColor,
    });
    if (!options.filled)
        return outline;
    const width = asNumber(options.width);
    const height = asNumber(options.height);
    const checkMarkSize = Math.min(width, height) / 2;
    const checkMark = drawCheckMark({
        x: width / 2,
        y: height / 2,
        size: checkMarkSize,
        thickness: options.thickness,
        color: options.markColor,
    });
    return [pushGraphicsState(), ...outline, ...checkMark, popGraphicsState()];
};
export const drawRadioButton = (options) => {
    const width = asNumber(options.width);
    const height = asNumber(options.height);
    const outlineScale = Math.min(width, height) / 2;
    const outline = drawEllipse({
        cx: options.x,
        cy: options.y,
        rx: outlineScale,
        ry: outlineScale,
        fill: options.color,
        stroke: options.borderColor,
        strokeWidth: options.borderWidth,
    });
    if (!options.filled)
        return outline;
    const dot = drawEllipse({
        cx: options.x,
        cy: options.y,
        rx: outlineScale * 0.45,
        ry: outlineScale * 0.45,
        fill: options.dotColor,
        stroke: undefined,
        strokeWidth: 0,
    });
    return [pushGraphicsState(), ...outline, ...dot, popGraphicsState()];
};
export const drawButton = (options) => {
    const x = asNumber(options.x);
    const y = asNumber(options.y);
    const width = asNumber(options.width);
    const height = asNumber(options.height);
    const background = drawRect({
        x,
        y,
        width,
        height,
        strokeWidth: options.borderWidth,
        fill: options.color,
        stroke: options.borderColor,
    });
    const lines = drawTextLines(options.textLines, {
        color: options.textColor,
        font: options.font,
        size: options.fontSize,
        rotate: degrees(0),
        xSkew: degrees(0),
        ySkew: degrees(0),
    });
    return [pushGraphicsState(), ...background, ...lines, popGraphicsState()];
};
export const drawTextLines = (lines, options) => {
    const ops = [
        beginText(),
        setFillingColor(options.color),
        setFontAndSize(options.font, options.size),
    ];
    for (let idx = 0, len = lines.length; idx < len; idx++) {
        const { encoded, x, y } = lines[idx];
        ops.push(rotateAndSkewTextRadiansAndTranslate(toRadians(options.rotate), toRadians(options.xSkew), toRadians(options.ySkew), x, y), showText(encoded));
    }
    ops.push(endText());
    return ops;
};
export const drawTextField = (options) => {
    const x = asNumber(options.x);
    const y = asNumber(options.y);
    const width = asNumber(options.width);
    const height = asNumber(options.height);
    const borderWidth = asNumber(options.borderWidth);
    const padding = asNumber(options.padding);
    const clipX = x + borderWidth / 2 + padding;
    const clipY = y + borderWidth / 2 + padding;
    const clipWidth = width - (borderWidth / 2 + padding) * 2;
    const clipHeight = height - (borderWidth / 2 + padding) * 2;
    const clippingArea = [
        moveTo(clipX, clipY),
        lineTo(clipX, clipY + clipHeight),
        lineTo(clipX + clipWidth, clipY + clipHeight),
        lineTo(clipX + clipWidth, clipY),
        closePath(),
        clip(),
        endPath(),
    ];
    const background = drawRect({
        x,
        y,
        width,
        height,
        strokeWidth: options.borderWidth,
        fill: options.color,
        stroke: options.borderColor,
    });
    const lines = drawTextLines(options.textLines, {
        color: options.textColor,
        font: options.font,
        size: options.fontSize,
        rotate: degrees(0),
        xSkew: degrees(0),
        ySkew: degrees(0),
    });
    const markedContent = [
        beginMarkedContent('Tx'),
        pushGraphicsState(),
        ...lines,
        popGraphicsState(),
        endMarkedContent(),
    ];
    return [
        pushGraphicsState(),
        ...background,
        ...clippingArea,
        ...markedContent,
        popGraphicsState(),
    ];
};
export const drawOptionList = (options) => {
    const x = asNumber(options.x);
    const y = asNumber(options.y);
    const width = asNumber(options.width);
    const height = asNumber(options.height);
    const lineHeight = asNumber(options.lineHeight);
    const borderWidth = asNumber(options.borderWidth);
    const padding = asNumber(options.padding);
    const clipX = x + borderWidth / 2 + padding;
    const clipY = y + borderWidth / 2 + padding;
    const clipWidth = width - (borderWidth / 2 + padding) * 2;
    const clipHeight = height - (borderWidth / 2 + padding) * 2;
    const clippingArea = [
        moveTo(clipX, clipY),
        lineTo(clipX, clipY + clipHeight),
        lineTo(clipX + clipWidth, clipY + clipHeight),
        lineTo(clipX + clipWidth, clipY),
        closePath(),
        clip(),
        endPath(),
    ];
    const background = drawRect({
        x,
        y,
        width,
        height,
        strokeWidth: options.borderWidth,
        fill: options.color,
        stroke: options.borderColor,
    });
    const highlights = [];
    for (let idx = 0, len = options.selectedLines.length; idx < len; idx++) {
        const text = options.textLines[options.selectedLines[idx]];
        highlights.push(...drawRect({
            x: text.x - padding,
            y: text.y - (lineHeight - text.height) / 2,
            width: width - borderWidth,
            height: text.height + (lineHeight - text.height) / 2,
            strokeWidth: 0,
            fill: options.selectedColor,
            stroke: undefined,
        }));
    }
    const lines = drawTextLines(options.textLines, {
        color: options.textColor,
        font: options.font,
        size: options.fontSize,
        rotate: degrees(0),
        xSkew: degrees(0),
        ySkew: degrees(0),
    });
    const markedContent = [
        beginMarkedContent('Tx'),
        pushGraphicsState(),
        ...lines,
        popGraphicsState(),
        endMarkedContent(),
    ];
    return [
        pushGraphicsState(),
        ...background,
        ...highlights,
        ...clippingArea,
        ...markedContent,
        popGraphicsState(),
    ];
};
export const graphicToOperators = (g, page) => {
    var _a, _b;
    const ops = [];
    // push a new graphic state that only applies to this graphic (and children)
    ops.push(pushGraphicsState());
    // maybe apply transforms to graphic state
    if (g.transform) {
        g.transform.forEach((t) => ops.push(t));
    }
    // maybe apply mix blend mode and opacity to graphic state
    if (g.mixBlendMode || g.opacity || g.strokeOpacity) {
        const graphicsState = page.doc.context.obj({
            Type: 'ExtGState',
            ca: g.opacity,
            CA: g.strokeOpacity,
            BM: g.mixBlendMode,
        });
        const GState = page.node.newExtGState('GS', graphicsState);
        ops.push(setGraphicsState(GState));
    }
    // maybe apply clipping to graphic state
    if (g.clipPath) {
        g.clipPath.forEach((o) => ops.push(o));
        ops.push(clip(g.clipRule));
        ops.push(endPath());
    }
    // draw shape, text or image to graphic state, or continue from groups child graphics
    switch (g.type) {
        case 'group':
            g.children.forEach((graphic) => {
                const operators = graphicToOperators(graphic, page);
                operators.forEach((o) => ops.push(o));
            });
            break;
        case 'shape':
            // apply all presentation attributes and later stripped those undefined
            ops.push(g.fill ? setFillingColor(g.fill) : undefined, g.stroke ? setStrokingColor(g.stroke) : undefined, g.strokeWidth ? setLineWidth(g.strokeWidth) : undefined, g.strokeLineJoin ? setLineJoin(g.strokeLineJoin) : undefined, // untested
            g.strokeMiterLimit ? setLineMiterLimit(g.strokeMiterLimit) : undefined, // untested
            g.strokeLineCap ? setLineCap(g.strokeLineCap) : undefined, // untested
            g.strokeDashArray || g.strokeDashOffset
                ? setDashPattern((_a = g.strokeDashArray) !== null && _a !== void 0 ? _a : [], (_b = g.strokeDashOffset) !== null && _b !== void 0 ? _b : 0) // untested
                : undefined);
            // apply operators that comprise the shape
            g.operators.forEach((o) => ops.push(o));
            // apply draw with fill and stroke, or separately
            ops.push(
            // prettier-ignore
            (g.fill && g.stroke) ? fillAndStroke(g.fillRule)
                : g.fill ? fill(g.fillRule)
                    : g.stroke ? stroke()
                        : undefined);
            break;
        case 'text':
            // TODO: add support for text
            break;
        case 'image':
            const name = page.node.newXObject('Image', g.image.ref);
            ops.push(translate(0, g.height)); // shift by height corrects flip
            ops.push(scale(g.width, -g.height)); // negative (flip) corrects upside down drawing
            ops.push(drawObject(name));
            break;
    }
    // pop current graphic state back to parents as this graphic is now complete
    ops.push(popGraphicsState());
    // only return defined operators
    return ops.filter(Boolean);
};
//# sourceMappingURL=operations.js.map